import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config/api";
import "../css/admin.css";
import PasswordInput from "../../components/PasswordInput";

const AdminLogin = () => {
  const navigate = useNavigate();

  // ── Login state ──
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");

  // ── Forgot password state ──
  const [showForgot,     setShowForgot]     = useState(false);
  const [forgotEmail,    setForgotEmail]    = useState("");
  const [forgotLoading,  setForgotLoading]  = useState(false);
  const [forgotMsg,      setForgotMsg]      = useState("");
  const [forgotError,    setForgotError]    = useState("");

  // ── Login ──
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res  = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();

      if (res.ok) {
        if (data.role !== "admin") {
          setError("Access denied. Admin accounts only.");
          setLoading(false);
          return;
        }
        localStorage.setItem("adminToken", data.token);
        localStorage.setItem("adminRole",  data.role);  // separate key — never clashes with ownerRole
        navigate("/admin/dashboard");
      } else {
        setError(data.message || "Invalid credentials");
      }
    } catch {
      setError("Cannot connect to server. Is the backend running?");
    }
    setLoading(false);
  };

  // ── Forgot password ──
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setForgotError("");
    setForgotMsg("");
    setForgotLoading(true);

    try {
      const res  = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: forgotEmail }),
      });
      const data = await res.json();

      if (res.ok) {
        setForgotMsg("✅ Password reset link sent! Check your email inbox.");
      } else {
        setForgotError(data.message || "Failed to send reset email.");
      }
    } catch {
      setForgotError("Cannot connect to server.");
    }
    setForgotLoading(false);
  };

  // ─────────────────────────────────────────
  // FORGOT PASSWORD SCREEN
  // ─────────────────────────────────────────
  if (showForgot) {
    return (
      <div className="admin-login-page">
        <div className="admin-login-card">
          <h2 className="admin-login-title">Forgot Password</h2>
          <p className="admin-login-subtitle">Enter your admin email — we'll send a reset link</p>

          {forgotMsg && (
            <div style={{ background: "#f0fdf4", color: "#15803d", padding: "10px 14px", borderRadius: "8px", marginBottom: "16px", fontSize: "14px" }}>
              {forgotMsg}
            </div>
          )}

          {forgotError && (
            <div style={{ background: "#fee2e2", color: "#dc2626", padding: "10px 14px", borderRadius: "8px", marginBottom: "16px", fontSize: "14px" }}>
              ⚠️ {forgotError}
            </div>
          )}

          {!forgotMsg && (
            <form onSubmit={handleForgotPassword}>
              <div className="admin-form-group">
                <label>Admin Email</label>
                <input
                  type="email"
                  placeholder="admin@example.com"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="admin-login-btn" disabled={forgotLoading}>
                {forgotLoading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>
          )}

          <p style={{ textAlign: "center", marginTop: "16px", fontSize: "14px" }}>
            <button
              onClick={() => { setShowForgot(false); setForgotMsg(""); setForgotError(""); }}
              style={{ background: "none", border: "none", color: "#4318ff", cursor: "pointer", fontWeight: "600" }}
            >
              ← Back to Login
            </button>
          </p>
        </div>
      </div>
    );
  }

  // ─────────────────────────────────────────
  // LOGIN SCREEN
  // ─────────────────────────────────────────
  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <h2 className="admin-login-title">Admin Login</h2>
        <p className="admin-login-subtitle">Fraud Detect System — Admin Panel</p>

        {error && (
          <div style={{ background: "#fee2e2", color: "#dc2626", padding: "10px 14px", borderRadius: "8px", marginBottom: "16px", fontSize: "14px" }}>
            ⚠️ {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div className="admin-form-group">
            <label>Email</label>
            <input
              type="email"
              placeholder="admin@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="admin-form-group">
            <label>Password</label>
            <PasswordInput
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {/* ✅ Forgot password link — BEFORE the login button */}
          <p style={{ textAlign: "right", marginBottom: "16px", marginTop: "-8px" }}>
            <button
              type="button"
              onClick={() => { setShowForgot(true); setError(""); }}
              style={{ background: "none", border: "none", color: "#4318ff", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}
            >
              Forgot Password?
            </button>
          </p>

          <button type="submit" className="admin-login-btn" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
